import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./App.css";
import Home from "./Pages/Home/Home";
import Header from "./Layout/Header";
import Footer from "./Layout/Footer";
import Services from "./Pages/Services/Services";
import ScrollToTop from "./Utils/ScrollToTop";
import Contact from "./Pages/Contact/Contact";
import About from "./Pages/About/About";
import Blogs from "./Pages/Blogs/Blogs";
import BlogDetails from "./Pages/Blogs/BlogDetails";
import PageNotFound from "./Pages/404Page/PageNotFound";
// import Gallery from "./Pages/Gallery/Gallery";
import PrivacyPolicy from "./Pages/PrivacyCondition/PrivacyPolicy";
import { ReactNotifications } from "react-notifications-component";
import ServiceDetails from "./Pages/Services/ServiceDetails";
import TermsConditions from "./Pages/PrivacyCondition/TermsConditions";
import ReturnPolicy from "./Pages/PrivacyCondition/ReturnPolicy";

function App() {
  return (
    <>
      <Router>
        <ReactNotifications />
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blog/:blogslug" element={<BlogDetails />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />
          <Route path="/service/:serviceslug" element={<ServiceDetails />} />
          <Route path="/about" element={<About />} />
          <Route path="/return-policy" element={<ReturnPolicy />} />
          <Route path="/terms-condition" element={<TermsConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/page-not-found" element={<PageNotFound />} />
          <Route path="*" element={<Navigate to="/page-not-found" replace />} />
        </Routes>
        <Footer />
      </Router>
    </>
  );
}

export default App;
